import { jsx as o } from "react/jsx-runtime";
import { QUERIES as r, BREAKPOINTS as M } from "@fcamna/shared-component-foundations";
import { fordProIcons as F } from "@fcamna/shared-icons";
import { createContext as _, useState as l, useRef as S, useEffect as T, useContext as k } from "react";
import d from "styled-components";
import { u as D } from "./useQuantum-50e8fd44.mjs";
import "./isClient-ec947a14.mjs";
import "./useSlots-a1aa6a84.mjs";
import { IconButton as Y } from "./iconButton.js";
import { u as Q } from "./useWindowDimensions-ae69e913.mjs";
import "./index-65016bfa.mjs";
import "./_commonjsHelpers-92157f1b.mjs";
import "./button.js";
import "./useAccessibilityProps-2f24cf29.mjs";
import "./setup-0f23222d.mjs";
import "react-dom";
import "./table.js";
import "./uniqueId-321287e8.mjs";
import "./icon.js";
const { OldPlay: O, Pause: X } = F, C = "100%", E = "1440px", q = "50%", G = "70%", K = () => `
  margin-block-start: unset;
  margin-block-end: unset;
  margin-inline-start: unset;
  margin-inline-end: unset;`, J = d.div`
  z-index: ${(e) => e.theme.components.heroVideo.Wrapper.zIndex};
  aspect-ratio: ${(e) => e.theme.components.heroVideo.Wrapper.aspectRatio};
  align-items: ${(e) => e.theme.components.heroVideo.Wrapper.alignItems};
  display: ${(e) => e.theme.components.heroVideo.Wrapper.display};
  position: ${(e) => e.theme.components.heroVideo.Wrapper.position};
  ${(e) => {
  switch (e.contentAlignment) {
    case "center":
      return `
        justify-content: ${e.theme.components.heroVideo.Wrapper.justifyContent.contentAlignmentCenter};
        `;
    case "right":
      return `
          justify-content: ${e.theme.components.heroVideo.Wrapper.justifyContent.contentAlignmentRight};
        `;
    case "left":
    default:
      return `
        justify-content: ${e.theme.components.heroVideo.Wrapper.justifyContent.contentAlignmentLeft};
        `;
  }
}}

  ${(e) => e.coverNavBar ? `
        margin-top: ${e.topNegativeMargin}px;
        margin-left: ${e.sideNegativeMargin}px;
        margin-right: ${e.sideNegativeMargin}px;
      ` : ""};

  @media ${r.tabletAndUp} {
    aspect-ratio: ${(e) => e.theme.components.heroVideo.Wrapper.tabletAndUp.aspectRatio};
  }
`, Z = d.div`
  position: ${(e) => e.theme.components.heroVideo.HeadingContent.position};
  z-index: ${(e) => e.theme.components.heroVideo.HeadingContent.zIndex};
  margin-left: ${(e) => e.theme.components.heroVideo.HeadingContent.marginLeft};
  margin-right: ${(e) => e.theme.components.heroVideo.HeadingContent.marginRight};
  width: ${(e) => e.theme.components.heroVideo.HeadingContent.width};
  max-width: ${(e) => {
  var t;
  return (t = e.maxWidthObj) == null ? void 0 : t.mobile;
}};
  letter-spacing: ${(e) => e.theme.components.heroVideo.HeadingContent.letterSpacing};

  ${(e) => {
  switch (e.contentAlignment) {
    case "center":
      return `
          text-align: ${e.theme.components.heroVideo.HeadingContent.textAlign.contentAlignmentCenter};
        `;
    case "right":
      return `
          text-align: ${e.theme.components.heroVideo.HeadingContent.textAlign.contentAlignmentRight};
        `;
    case "left":
    default:
      return `
          text-align: ${e.theme.components.heroVideo.HeadingContent.textAlign.contentAlignmentLeft};
        `;
  }
}};

  @media ${r.tabletAndUp} {
    max-width: ${(e) => {
  var t;
  return (t = e.maxWidthObj) == null ? void 0 : t.tablet;
}};
  }

  @media ${r.laptopAndUp} {
    ${(e) => {
  switch (e.contentAlignment) {
    case "center":
      return `
          margin-right: ${e.theme.components.heroVideo.HeadingContent.laptopAndUp.marginRight.contentAlignmentCenter};
          margin-left: ${e.theme.components.heroVideo.HeadingContent.laptopAndUp.marginLeft.contentAlignmentCenter};
        `;
    case "right":
    case "left":
    default:
      return `
          margin-left: ${e.theme.components.heroVideo.HeadingContent.laptopAndUp.marginLeft.default};
          margin-right: ${e.theme.components.heroVideo.HeadingContent.laptopAndUp.marginRight.default};
        `;
  }
}}

    max-width: ${(e) => {
  var t;
  return (t = e.maxWidthObj) == null ? void 0 : t.laptop;
}};
  }

  @media ${r.desktopAndUp} {
    ${(e) => {
  switch (e.contentAlignment) {
    case "center":
      return `
          margin-right: ${e.theme.components.heroVideo.HeadingContent.desktopAndUp.marginRight.contentAlignmentCenter};
          margin-left: ${e.theme.components.heroVideo.HeadingContent.desktopAndUp.marginLeft.contentAlignmentCenter};
        `;
    case "right":
    case "left":
    default:
      return `
          margin-left: ${e.theme.components.heroVideo.HeadingContent.desktopAndUp.marginLeft.default};
          margin-right:${e.theme.components.heroVideo.HeadingContent.desktopAndUp.marginRight.default};
        `;
  }
}}

    max-width: ${(e) => {
  var t;
  return (t = e.maxWidthObj) == null ? void 0 : t.desktop;
}};
  }

  @media ${r.wideScreenAndUp} {
    margin-right: ${(e) => e.theme.components.heroVideo.HeadingContent.wideScreenAndUp.marginRight};
    margin-left: ${(e) => e.theme.components.heroVideo.HeadingContent.wideScreenAndUp.marginLeft};

    max-width: ${E};

    > * {
      max-width: ${(e) => {
  var t;
  return (t = e.maxWidthObj) == null ? void 0 : t.wideScreenAndUp;
}};
    }
  }
`, ee = d.div`
  position: ${(e) => e.theme.components.heroVideo.VideoWrapper.position};
  top: ${(e) => e.theme.components.heroVideo.VideoWrapper.top};
  left: ${(e) => e.theme.components.heroVideo.VideoWrapper.left};
  height: ${(e) => e.theme.components.heroVideo.VideoWrapper.height};
  width: ${(e) => e.theme.components.heroVideo.VideoWrapper.width};
  overflow: ${(e) => e.theme.components.heroVideo.VideoWrapper.overflow};
  background-color: ${(e) => e.theme.components.heroVideo.VideoWrapper.backgroundColor};
`, te = d.div`
  position: ${(e) => e.theme.components.heroVideo.VideoOverlayWrapper.position};
  top: ${(e) => e.theme.components.heroVideo.VideoOverlayWrapper.top};
  left: ${(e) => e.theme.components.heroVideo.VideoOverlayWrapper.left};
  height: ${(e) => e.theme.components.heroVideo.VideoOverlayWrapper.height};
  width: ${(e) => e.theme.components.heroVideo.VideoOverlayWrapper.width};
  overflow: ${(e) => e.theme.components.heroVideo.VideoOverlayWrapper.overflow};
  background-color: ${(e) => e.theme.components.heroVideo.VideoOverlayWrapper.backgroundColor};
  z-index: ${(e) => e.theme.components.heroVideo.VideoOverlayWrapper.zIndex};
  background: ${(e) => e.theme.components.heroVideo.VideoOverlayWrapper.background};

  ${(e) => e.isPlaying ? `opacity: ${e.playingOpacity};` : `opacity: ${e.pausedOpacity};`}
`, oe = d.div`
  height: ${(e) => e.theme.components.heroVideo.VideoElementWrapper.height};
  width: ${(e) => e.theme.components.heroVideo.VideoElementWrapper.width};

  div,
  video {
    position: ${(e) => e.theme.components.heroVideo.VideoElementWrapper.divVideo.position};
    min-height: ${(e) => e.theme.components.heroVideo.VideoElementWrapper.divVideo.minHeight};
    width: ${(e) => e.theme.components.heroVideo.VideoElementWrapper.divVideo.width};
    max-width: ${(e) => e.theme.components.heroVideo.VideoElementWrapper.divVideo.maxWidth};
    -o-object-fit: ${(e) => e.theme.components.heroVideo.VideoElementWrapper.divVideo.objectFit};
    object-fit: ${(e) => e.theme.components.heroVideo.VideoElementWrapper.divVideo.objectFit};
    z-index: ${(e) => e.theme.components.heroVideo.VideoElementWrapper.divVideo.zIndex};
  }
`, ne = d.h1`
  && {
    color: ${(e) => e.theme.components.heroVideo.VideoTitleWrapper.color};
    font-family: ${(e) => e.theme.components.heroVideo.VideoTitleWrapper.fontFamily};
    font-weight: ${(e) => e.theme.components.heroVideo.VideoTitleWrapper.fontWeight};
    font-size: ${(e) => e.theme.components.heroVideo.VideoTitleWrapper.fontSize};
    line-height: ${(e) => e.theme.components.heroVideo.VideoTitleWrapper.lineHeight};
    letter-spacing: ${(e) => e.theme.components.heroVideo.VideoTitleWrapper.letterSpacing};
    margin: ${(e) => e.theme.components.heroVideo.VideoTitleWrapper.margin};
  }
`, ie = d.p`
  ${K()}
  font-family: ${(e) => e.theme.components.heroVideo.VideoBodyWrapper.fontFamily};
  font-weight: ${(e) => e.theme.components.heroVideo.VideoBodyWrapper.fontWeight};
  font-size: ${(e) => e.theme.components.heroVideo.VideoBodyWrapper.fontSize};
  line-height: ${(e) => e.theme.components.heroVideo.VideoBodyWrapper.lineHeight};
  letter-spacing: ${(e) => e.theme.components.heroVideo.VideoBodyWrapper.letterSpacing};
  color: ${(e) => e.theme.components.heroVideo.VideoBodyWrapper.color};
  margin-bottom: ${(e) => e.theme.components.heroVideo.VideoBodyWrapper.marginBottom};

  @media ${r.tabletAndUp} {
    font-weight: ${(e) => e.theme.components.heroVideo.VideoBodyWrapper.tabletAndUp.fontWeight};
    font-size: ${(e) => e.theme.components.heroVideo.VideoBodyWrapper.tabletAndUp.fontSize};
    line-height: ${(e) => e.theme.components.heroVideo.VideoBodyWrapper.tabletAndUp.lineHeight};
  }
`, re = d.div`
  > button {
    width: ${(e) => e.theme.components.heroVideo.VideoButtonsWrapper.button.width};

    margin-bottom: ${(e) => e.theme.components.heroVideo.VideoButtonsWrapper.button.marginBottom};
  }

  @media ${r.tabletAndUp} {
    > button {
      width: ${(e) => e.theme.components.heroVideo.VideoButtonsWrapper.tabletAndUp.button.width};
      margin-bottom: ${(e) => e.theme.components.heroVideo.VideoButtonsWrapper.tabletAndUp.button.marginBottom};
    }
  }
`, de = d.div`
  z-index: ${(e) => e.theme.components.heroVideo.VideoPlaybackButtonWrapper.zIndex};
  position: ${(e) => e.theme.components.heroVideo.VideoPlaybackButtonWrapper.position};
  display: ${(e) => e.theme.components.heroVideo.VideoPlaybackButtonWrapper.display};
  bottom: ${(e) => e.theme.components.heroVideo.VideoPlaybackButtonWrapper.bottom};

  ${(e) => {
  switch (e.buttonAlignment) {
    case "right":
      return e.theme.components.heroVideo.VideoPlaybackButtonWrapper.buttonAlignment.right;
    case "left":
    default:
      return e.theme.components.heroVideo.VideoPlaybackButtonWrapper.buttonAlignment.left;
  }
}}

  @media ${r.tabletAndUp} {
    bottom: ${(e) => e.theme.components.heroVideo.VideoPlaybackButtonWrapper.tabletAndUp.bottom};
  }

  @media ${r.laptopAndUp} {
    bottom: ${(e) => e.theme.components.heroVideo.VideoPlaybackButtonWrapper.laptopAndUp.bottom};

    ${(e) => {
  switch (e.buttonAlignment) {
    case "right":
      return `right: ${e.theme.components.heroVideo.VideoPlaybackButtonWrapper.laptopAndUp.buttonAlignment.right};`;
    case "left":
    default:
      return `left: ${e.theme.components.heroVideo.VideoPlaybackButtonWrapper.laptopAndUp.buttonAlignment.left};`;
  }
}}
  }

  @media ${r.desktopAndUp} {
    bottom: ${(e) => e.theme.components.heroVideo.VideoPlaybackButtonWrapper.desktopAndUp.bottom};

    ${(e) => {
  switch (e.buttonAlignment) {
    case "right":
      return `right: ${e.theme.components.heroVideo.VideoPlaybackButtonWrapper.desktopAndUp.buttonAlignment.right}`;
    case "left":
    default:
      return `left: ${e.theme.components.heroVideo.VideoPlaybackButtonWrapper.desktopAndUp.buttonAlignment.left}`;
  }
}}
  }

  @media ${r.wideScreenAndUp} {
    ${(e) => `
          right: ${e.theme.components.heroVideo.VideoPlaybackButtonWrapper.wideScreenAndUp.right};
          left: ${e.theme.components.heroVideo.VideoPlaybackButtonWrapper.wideScreenAndUp.left};
          width: ${e.theme.components.heroVideo.VideoPlaybackButtonWrapper.wideScreenAndUp.width};
          bottom:${e.theme.components.heroVideo.VideoPlaybackButtonWrapper.wideScreenAndUp.bottom};

          > div {
            max-width: ${e.theme.components.heroVideo.VideoPlaybackButtonWrapper.wideScreenAndUp.div.maxWidth};
            width: ${e.theme.components.heroVideo.VideoPlaybackButtonWrapper.wideScreenAndUp.div.width};
            min-width:  ${e.theme.components.heroVideo.VideoPlaybackButtonWrapper.wideScreenAndUp.div.minWidth};
            margin: ${e.theme.components.heroVideo.VideoPlaybackButtonWrapper.wideScreenAndUp.div.margin};
            position:  ${e.theme.components.heroVideo.VideoPlaybackButtonWrapper.wideScreenAndUp.div.position};

            > button.cxcHeroVideoPlayButton {
              position:  ${e.theme.components.heroVideo.VideoPlaybackButtonWrapper.wideScreenAndUp.div.cxcHeroVideoPlayButton.position};

              ${e.buttonAlignment === "right" ? `right: ${e.theme.components.heroVideo.VideoPlaybackButtonWrapper.wideScreenAndUp.div.cxcHeroVideoPlayButton.buttonAlignment.right};` : `left: ${e.theme.components.heroVideo.VideoPlaybackButtonWrapper.wideScreenAndUp.div.cxcHeroVideoPlayButton.buttonAlignment.left};`}
            }
          }
        `}
  }
`;
function ae({ children: e, ...t }) {
  return /* @__PURE__ */ o(ee, { ...t, children: e });
}
function me({ maxWidthObj: e, children: t, ...n }) {
  const { contentAlignment: i, coverNavBar: c } = k(b), a = Object.assign(
    {
      wideScreenAndUp: E,
      desktop: C,
      laptop: C,
      tablet: C,
      mobile: C
    },
    e
  );
  return /* @__PURE__ */ o(
    Z,
    {
      contentAlignment: i,
      coverNavBar: c,
      maxWidthObj: a,
      ...n,
      children: t
    }
  );
}
function pe({ children: e, ...t }) {
  return /* @__PURE__ */ o(ne, { ...t, children: e });
}
function ce({ children: e, ...t }) {
  return /* @__PURE__ */ o(ie, { ...t, children: e });
}
function he({ children: e, ...t }) {
  return /* @__PURE__ */ o(re, { ...t, children: e });
}
function le({ children: e, onClick: t, size: n, ...i }) {
  const { isPlaying: c, playbackIcon: a, handleOnClick: $, coverNavBar: s, playButtonSize: u } = k(b);
  function V(g) {
    $(), t == null || t(g, !c);
  }
  return /* @__PURE__ */ o(
    de,
    {
      coverNavBar: s,
      ...i,
      children: /* @__PURE__ */ o("div", { children: /* @__PURE__ */ o(
        Y,
        {
          className: "cxcHeroVideoPlayButton",
          icon: a,
          onClick: V,
          size: n || u
        }
      ) })
    }
  );
}
function se({
  videoProps: e,
  onPlay: t,
  onPause: n,
  onEnded: i,
  loopAmount: c = 0,
  pauseTime: a = -1,
  ...$
}) {
  const { defaultVideoProps: s, loopCount: u, setLoopCountFunc: V } = k(b), { onPlay: g, onPause: W, loop: A, ref: f, ...w } = s, y = Math.floor(c);
  function P() {
    g(), t == null || t();
  }
  function U() {
    W(), n == null || n();
  }
  function x() {
    if (y > 0) {
      const h = f == null ? void 0 : f.current;
      u + 1 < y ? (V(u + 1), h.currentTime = 0, h.play()) : (a >= 0 && (h.currentTime = a), h.pause());
    }
    i == null || i();
  }
  return /* @__PURE__ */ o(
    oe,
    {
      videoProps: e,
      ...$,
      children: /* @__PURE__ */ o(
        "video",
        {
          ...w,
          loop: y > 0 ? !1 : A,
          ...e,
          onPlay: P,
          onPause: U,
          onEnded: x,
          ref: f
        }
      )
    }
  );
}
function ue({
  playingOpacity: e = q,
  pausedOpacity: t = G,
  ...n
}) {
  const { isPlaying: i } = k(b);
  return /* @__PURE__ */ o(
    te,
    {
      playingOpacity: e,
      pausedOpacity: t,
      isPlaying: i,
      ...n
    }
  );
}
const b = _({
  defaultVideoProps: {
    loop: !0,
    ref: void 0,
    onPlay: () => {
    },
    onPause: () => {
    }
  },
  isPlaying: !1,
  playbackIcon: /* @__PURE__ */ o(O, {}),
  playButtonSize: "medium",
  handleOnClick: () => {
  },
  contentAlignment: "left",
  coverNavBar: !1,
  loopCount: 0,
  setLoopCountFunc: (e) => {
  }
});
function p({ children: e, contentAlignment: t = "left", coverNavBar: n = !1, isLoggedIn: i = !1, ...c }) {
  const a = D({ label: "Hero Video" }), [$, s] = l("medium"), [u, V] = l(/* @__PURE__ */ o(O, {})), [g, W] = l(!1), [A, f] = l(0), [w, y] = l(0), [P, U] = l(window.document.body.offsetHeight), [x, h] = l(0), B = S(null), v = S(null), { width: H } = Q();
  function z() {
    V(/* @__PURE__ */ o(O, {})), W(!1);
  }
  function I() {
    V(/* @__PURE__ */ o(X, {})), W(!0);
  }
  function j() {
    const m = B == null ? void 0 : B.current;
    g ? m.pause() : (h(0), m.play());
  }
  T(() => {
    const m = new ResizeObserver(() => U(window.document.body.offsetHeight));
    return m.observe(window.document.body), () => m.disconnect();
  }, []), T(() => {
    const m = (v == null ? void 0 : v.current).getBoundingClientRect(), R = window.pageYOffset + m.top, L = m.left;
    y(w - L), f(A - R), H < M.laptopMin ? s("medium") : s("large");
  }, [H, i, P]);
  const N = {
    playsInline: !0,
    autoPlay: !0,
    muted: !0,
    loop: !0,
    onPlay: I,
    onPause: z,
    ref: B,
    role: "video"
  };
  return /* @__PURE__ */ o(
    J,
    {
      contentAlignment: t,
      coverNavBar: n,
      ref: v,
      topNegativeMargin: A,
      sideNegativeMargin: w,
      ...c,
      ...a,
      children: /* @__PURE__ */ o(
        b.Provider,
        {
          value: {
            defaultVideoProps: N,
            isPlaying: g,
            handleOnClick: j,
            playbackIcon: u,
            playButtonSize: $,
            contentAlignment: t,
            coverNavBar: n,
            loopCount: x,
            setLoopCountFunc: h
          },
          children: e
        }
      )
    }
  );
}
p.HeaderContainer = me;
p.VideoContainer = ae;
p.Title = pe;
p.Body = ce;
p.CTAButtonContainer = he;
p.PlaybackButton = le;
p.VideoElement = se;
p.Overlay = ue;
export {
  p as HeroVideo
};
